import { useCallback, useEffect } from 'react';

import {
  getTablePageSize,
  saveTablePageSize,
  setTableColumns,
  updateTableColumns
} from './localstorageUtils';
import Optional from './optional';

const useLocalTableStore = ({
  tableName,
  setColumns,
  tableDefaultColumns,
  language,
  tableNameForPageSize = null
}) => {
  useEffect(() => {
    setTableColumns({ setColumns, tableDefaultColumns, tableName });
    // eslint-disable-next-line
  }, [setColumns, tableDefaultColumns, language, tableName]);

  const pageSize = getTablePageSize({ tableName });

  const onChangeRowsPerPage = useCallback(
    pageSize => {
      saveTablePageSize({
        tableName: Optional(tableNameForPageSize).or(tableName),
        pageSize
      });
    },
    [tableName, tableNameForPageSize]
  );

  const onChangeColumnHidden = useCallback(
    (columnData, hidden) => {
      updateTableColumns({
        columnData,
        hidden,
        setColumns,
        tableDefaultColumns,
        tableName
      });
    },
    // eslint-disable-next-line
    [setColumns, tableDefaultColumns, language, tableName]
  );

  return { pageSize, onChangeRowsPerPage, onChangeColumnHidden };
};

export default useLocalTableStore;
